import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [user, loading, error] = useAuthState(auth);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#17140f] flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-[#e2916d] animate-spin mx-auto mb-4" />
          <p className="text-[#b9ad9b]">Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#17140f] flex items-center justify-center">
        <div className="text-center">
          <div className="bg-[#341a17] text-[#f38b83] p-4 rounded-lg">
            <p>Authentication error: {error.message}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;